import { observer } from "mobx-react-lite";
import StyleSelector from "./style-radio";
import { SVGPureIcon } from "@/ui";

type Props = {
  children: any,
  title: string,
  onScroll?: () => void,
  isRequired?: boolean,
  style?: React.CSSProperties,
  className?: string,
  titleStyle?: React.CSSProperties,
  titleActionComp?: React.ReactNode
}

const AigcFormItem = ({ children, title, isRequired = false, titleActionComp, style, titleStyle, className = '' }: Props) => {

  return (
    <div style={style} className={`aigc-form-item text-black text-black-opacity-13 leading-22px font-14px p-16px mb-16px rounded-12px bg-[#F7F8FC] w-full ${className}`}>
     {
      title &&
       <h3 className="mb-12px flex gap-4px items-center" style={titleStyle}>
       {
         isRequired &&
         <SVGPureIcon name='required' size={16} color="#FF4057"/>
       }
       {title}
       <div className="ml-auto cursor-pointer active:translate-x-1px active:translate-y-1px">
         {
           titleActionComp
         }
       </div>
     </h3>
     }
      {children}
    </div>
  )
}

export default observer(AigcFormItem);